import lottie from 'lottie-web';
import { useEffect, useRef } from 'react';
import animation from './loader.json';
import styles from './ui.module.css';

export function Loader() {
  const host = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = host.current;
    if (node === null) return;

    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const player = lottie.loadAnimation({
      container: node,
      renderer: 'svg',
      loop: true,
      autoplay: !still,
      animationData: animation,
    });
    if (still) player.goToAndStop(58, true);

    return () => player.destroy();
  }, []);

  return <div ref={host} className={styles.loader} aria-hidden="true" />;
}
